import React, { Component } from "react";
import { ContextIF } from "../../App";
import { withContext } from "../shared/withContext";
import { Redirect } from "react-router";
import { Tag } from "primereact/tag";
import firebase from "../../../node_modules/firebase/compat/app";
import "firebase/compat/auth";
import { Button } from "primereact/button";
import {
  redirectToCustomerPortal,
  startStripeSession,
} from "../../logik/apiCalls";
import { isAllreadyReviewed } from "../../parameter";

interface Props {
  context: ContextIF;
}
interface State {
  loading: boolean;
}

class Account extends Component<Props, State> {
  state = {
    loading: false,
  };

  render() {
    return (
      <>
        {this.props.context.user ? (
          <div>
            <table>
              <tbody>
                <tr>
                  <td>Konto Username:</td>
                  <td>{this.props.context.user.displayName}</td>
                </tr>
                <tr>
                  <td>Email:</td>
                  <td>{this.props.context.user.email}</td>
                </tr>
                {isAllreadyReviewed && (
                  <tr>
                    <td>Vollversion abonniert:</td>
                    <td>
                      {this.props.context.hasPremium ? (
                        <Tag
                          className="p-mr-2"
                          icon="pi pi-check"
                          severity="success"
                          value="Ja"
                        ></Tag>
                      ) : (
                        <Tag
                          className="p-mr-2"
                          icon="pi pi-times"
                          severity="danger"
                          value="Nein"
                        ></Tag>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="p-d-flex p-jc-center p-flex-column">
              {isAllreadyReviewed && this.props.context.hasPremium && (
                <Button
                  loading={this.state.loading}
                  className=" p-mx-2"
                  label="Abonnement verwalten"
                  onClick={() => {
                    this.setState({ loading: true });
                    redirectToCustomerPortal();
                  }}
                />
              )}
              {isAllreadyReviewed && !this.props.context.hasPremium && (
                <Button
                  loading={this.state.loading}
                  className=" p-mt-3 p-mx-2"
                  label="Jetzt abonnieren"
                  icon="pi pi-star"
                  onClick={() => {
                    this.setState({ loading: true });
                    startStripeSession("price_1LjMg7ARrsSEnK5qRWyIQVBv");
                  }}
                ></Button>
              )}
            </div>
            {!isAllreadyReviewed && (
              <div className="p-d-flex p-jc-center  p-flex-column">
                <Button
                  className=" p-mt-3 p-mx-2 p-button-danger"
                  label="Daten löschen lassen"
                  onClick={() => {
                    window.location.assign(
                      "https://rohdemusik.de/anfrage-zur-loeschung-persoenlicher-daten-der-stimmfix-app/"
                    );
                  }}
                ></Button>
              </div>
            )}
            <div className="p-d-flex p-jc-center  p-flex-column">
              <Button
                className=" p-mt-3 p-mx-2"
                label="Ausloggen"
                onClick={() => {
                  firebase.auth().signOut();
                  window.location.reload();
                }}
              ></Button>
            </div>
          </div>
        ) : (
          <Redirect to="/login" />
        )}
      </>
    );
  }
}
export const AccountWithoutContext = Account;
export default withContext(Account);
